import ScrollMagic from 'scrollmagic';

window.addEventListener('load', () => {
	const controller = new ScrollMagic.Controller();
	const navigationHldAll = document.querySelectorAll('.js-table-of-contents-hld');

	navigationHldAll.forEach(navHld => {
		const navigation = navHld.querySelector('.js-table-of-contents-navigation');
		const content = navHld.querySelector('.js-table-of-contents-content');
		const headingAll = content.querySelectorAll('.js-content h3');

		let activeNavigationItem = null;

		function activateNavigationItem(index) {
			if (activeNavigationItem) {
				activeNavigationItem.classList.remove('is-active');
			}
			const newNavigationItem = navigation.querySelector(`[data-anchor="${index}"]`);
			if (newNavigationItem) {
				newNavigationItem.classList.add('is-active');
				activeNavigationItem = newNavigationItem;
			}
		}

		headingAll.forEach((heading, index) => {
			heading.dataset.anchor = index;
			const headingValue = heading.innerHTML;
			const newNavigationItem = document.createElement('div');
			newNavigationItem.innerHTML = headingValue;
			newNavigationItem.classList.add('table-of-contents-navigation-item');
			newNavigationItem.dataset.anchor = index;
			navigation.appendChild(newNavigationItem);

			newNavigationItem.addEventListener('click', () => {
				const offset = 180;
				heading.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest', offset: offset });
				activateNavigationItem(index);
			});

			if (index === 0) {
				newNavigationItem.classList.add('is-first');
			}
			// eslint-disable-next-line
			let scene = new ScrollMagic.Scene({
				triggerElement: heading,
			})
				.triggerHook(0.25)
				.on('enter', () => {
					activateNavigationItem(index);
				})
				.addTo(controller);
		});

		window.addEventListener('scroll', () => {
			const visibleHeadings = Array.from(headingAll).filter(heading => {
				const rect = heading.getBoundingClientRect();
				return rect.top >= 0 && rect.bottom <= window.innerHeight;
			});

			if (visibleHeadings.length > 0) {
				const index = Array.from(headingAll).indexOf(visibleHeadings[0]);
				activateNavigationItem(index);
			}
		});
	});
});
